module.exports = __webpack_public_path__ + "img/kz.de317df5.svg";